"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Breadcrumbs = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_1 = require("@icr-ui/icons");
const theme_1 = require("@icr-ui/theme");
const react_1 = require("react");
const typography_1 = require("../typography");
const styles_1 = require("./styles");
exports.Breadcrumbs = (0, react_1.forwardRef)((props, ref) => {
    const { items } = props;
    if (items.length > 3) {
        items[1].label = '...';
    }
    return ((0, jsx_runtime_1.jsx)(styles_1.StyledBreadCrumbs, { flexDirection: "row", alignItems: "center", gap: "18px", ...{ ref }, "data-testid": "breadcrumb-wrapper", children: items.map((item, i) => {
            const lastItem = items[items.length - 1];
            return ((0, jsx_runtime_1.jsxs)(styles_1.StyledBreadCrumbsItem, { alignItems: "center", flexDirection: "row", gap: "18px", ...item, "data-testid": "breadcrumb", children: [(0, jsx_runtime_1.jsx)(typography_1.Typography, { variant: "body", size: "tiny", weight: "medium", "data-testid": "breadcrumb-label", children: item.label }), lastItem.label !== item.label && ((0, jsx_runtime_1.jsx)(icons_1.ChevronRightIcon, { color: theme_1.grayScale[600], width: 8, height: 8, "data-testid": "breadcrumb-icon" }))] }, i));
        }) }));
});
exports.Breadcrumbs.displayName = 'Breadcrumbs';
exports.default = exports.Breadcrumbs;
//# sourceMappingURL=breadcrumbs.js.map